/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/
import { cn } from '@/lib/utils'

type SettingsSectionProps = {
  title: string
  titleProps?: React.HTMLAttributes<HTMLHeadingElement>
  description?: string
  children: React.ReactNode
  className?: string
}

export function SettingsSection({
  title,
  titleProps,
  description,
  children,
  className,
}: SettingsSectionProps) {
  return (
    <section className={cn('space-y-4', className)}>
      {/* Noya-style section header: left teal accent bar + title block */}
      <div className='flex items-start gap-3'>
        <span
          className='mt-0.5 h-5 w-0.5 shrink-0 rounded-full bg-primary'
          aria-hidden='true'
        />
        <div className='min-w-0 space-y-0.5'>
          <h3
            {...titleProps}
            className={cn(
              'text-sm font-semibold leading-snug tracking-tight',
              titleProps?.className
            )}
          >
            {title}
          </h3>
          {description && (
            <p className='text-muted-foreground text-xs leading-relaxed'>
              {description}
            </p>
          )}
        </div>
      </div>
      {children}
    </section>
  )
}
